import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import linkedinIcon from '../../assets/icons/linkedin.png';
import instagramIcon from '../../assets/icons/instagram.png';
import emailIcon from '../../assets/icons/email.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="social-icons">
            <a 
              href="https://linkedin.com/company/fundacao-theodomiro-santiago?originalSubdomain=br" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="LinkedIn da Fundação Theodomiro Santiago"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
            </a>
            <a 
              href="https://www.instagram.com/fundacaotheodomirosantiago/" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Instagram da Fundação Theodomiro Santiago"
            >
              <img src={instagramIcon} alt="Instagram" className="social-icon" />
            </a>
            <Link 
              to="/contato"
              aria-label="Enviar email - ir para página de contato"
            >
              <img src={emailIcon} alt="Email" className="social-icon" />
            </Link>
          </div>
        </div>

        <div className="footer-right">
          <p className="company-name">
            Fundação Theodomiro Santiago
          </p>
          <p className="copyright">
            © 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
